// Environment configuration for Cloudflare deployment
const isProduction = process.env.NODE_ENV === 'production';
const isCloudflarePages = window.location.hostname.includes('pages.dev') || window.location.hostname.includes('workers.dev');

// API Base URL configuration
export const API_BASE_URL = (() => {
  if (isProduction && isCloudflarePages) {
    // Production deployment on Cloudflare
    return 'https://digital-twin-backend.kanosei.workers.dev/api';
  } else if (isProduction) {
    // Production deployment elsewhere
    return 'https://your-backend-domain.com/api';
  } else {
    // Development
    return 'http://localhost:5001/api';
  }
})();

// WebSocket URL configuration
export const WS_BASE_URL = (() => {
  if (isProduction && isCloudflarePages) {
    // Production deployment on Cloudflare
    return 'wss://digital-twin-backend.kanosei.workers.dev';
  } else if (isProduction) {
    // Production deployment elsewhere
    return 'wss://your-backend-domain.com';
  } else {
    // Development
    return 'ws://localhost:5001';
  }
})();

// Environment variables
export const ENV = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  API_BASE_URL,
  WS_BASE_URL,
  IS_PRODUCTION: isProduction,
  IS_CLOUDFLARE: isCloudflarePages,
} as const;
